// extracted by mini-css-extract-plugin
module.exports = {"NoDataMsg":"OrdersBarChart_NoDataMsg__RC4nD"};